import React, {useState, useEffect, useRef} from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {Panel} from "primereact/panel";
import {Sidebar} from "primereact/sidebar";
import {Message} from "primereact/message";
import {Dialog} from "primereact/dialog";

import _FM_GroupListComponent from "../components/_FM_group/_FM_GroupListComponent";
import _FM_GroupFormComponent from "../components/_FM_group/_FM_GroupFormComponent";
import _FM_GroupShowComponent from "../components/_FM_group/_FM_GroupShowComponent";
import _FM_GroupImportFormComponent from "../components/_FM_group/_FM_GroupImportFormComponent";
import _FM_GroupAutodistributeFormComponent from "../components/_FM_group/_FM_GroupAutodistributeComponent";
import _FM_GroupManualdistributeFormComponent from "../components/_FM_group/_FM_GroupManualdistributeComponent";
import HelpComponent from "../components/HelpComponent";
import _FM_CustomerShowComponent from "../components/_FM_customer/_FM_CustomerShowComponent";
import _FM_CustomerFormComponent from "../components/_FM_customer/_FM_CustomerFormComponent";

const _FM_GroupPage = (props) => {

  const {t, i18n} = props;
  const navigate = useNavigate();
  const {id, action, entity} = useParams();
  useEffect(() => {
    document.title = t('groups') + ' - ' + process.env.REACT_APP_TITLE;
    window.App.help('/group')
  }, []);

  return (
    <div className="_FM_GroupPage p-component p-m-lg-4">
      <HelpComponent type={"site"} position={"TOP_OF_THE_PAGE"} url={"/group"}/>
      <Panel>
        <_FM_GroupListComponent/>
      </Panel>
      <Sidebar position="right" visible={!entity && (action === 'create' || action === 'update')} closeOnEscape={true}
               style={{width: '980px'}}
               onHide={() => {
                 navigate('/group');
               }}>
        <_FM_GroupFormComponent/>
      </Sidebar>
      <Sidebar position="right" visible={action === 'read'} closeOnEscape={true}
               style={{width: '980px'}}
               onHide={() => {
                 navigate('/group');
               }}>
        <_FM_GroupShowComponent/>
      </Sidebar>
      <Dialog visible={window.App.urlVars().import === 'group'}
              header={t('group_import')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info"
                                               text={t("dialog_movable")}/></React.Fragment>}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_GroupImportFormComponent/>
      </Dialog>
      <Dialog visible={window.App.urlVars().distribute === 'auto'}
              header={t('group_distribute')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info"
                                               text={t("dialog_movable")}/></React.Fragment>}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_GroupAutodistributeFormComponent groupId={id} />
      </Dialog>
      <Dialog visible={window.App.urlVars().distribute === 'manual'}
              header={t('group_manual_distribute')}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              draggable={false}
              style={{width: '99%'}}>
        <_FM_GroupManualdistributeFormComponent groupId={id} />
      </Dialog>
      <Dialog visible={window.App.urlVars().read === 'customer'}
              header={t('customer')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info"
                                               text={t("dialog_movable")}/></React.Fragment>}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_CustomerShowComponent />
      </Dialog>
      <Dialog visible={window.App.urlVars().update === 'customer'}
              header={t('customer')}
              footer={<React.Fragment><Message className={"w-100"} style={{background: 'transparent'}} severity="info"
                                               text={t("dialog_movable")}/></React.Fragment>}
              onHide={() => {
                navigate(-1);
              }}
              modal={false}
              style={{minWidth: '980px', width: '980px', maxWidth: '980px'}}>
        <_FM_CustomerFormComponent />
      </Dialog>
    </div>
  )
}
export default withTranslation('common')(_FM_GroupPage);
